export const ARE_YOU_SURE = 'Are you sure you want to delete the record?';
export const ACTION_IS_IRREVERSIBLE_DELETED =
  'This action is irreversible, the record will be deleted.';
